// extracted by mini-css-extract-plugin
export default {"container":"vision_container__28i0L","right":"vision_right__RfRBU","left":"vision_left__SAXQj"};